import { Root } from './app/components/root.component';
import ReactDOM from 'react-dom';
import React from 'react';
import "jquery";
import "jquery-easing";
var containerElement = document.getElementById("bridge-container");
containerElement ? ReactDOM.render(React.createElement(Root, null), containerElement) : false;